import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'accountsToggleInput', 'accountsLabel', 'accountCheckbox'];

  formTarget: HTMLFormElement;

  accountsLabelTarget: HTMLLabelElement;

  accountCheckboxTargets: HTMLInputElement[];

  debounceTimeout: number;

  submit() {
    this.formTarget.requestSubmit();
  }

  onChangeAccountCheckbox() {
    this.debouncedSubmit();
  }

  debouncedSubmit() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = window.setTimeout(() => {
      this.formTarget.requestSubmit();
    }, 2000);
  }
}
